import { coverPage } from './cover-page';
import { slide1 } from './slide1';
import { slide2 } from './slide2';
import { slide3 } from './slide3';
import { slide4 } from './slide4';
import { slide5 } from './slide5';
import { slide6 } from './slide6';
import { slide7 } from './slide7';
import { slide8 } from './slide8';
import { slide9 } from './slide9';
import { slide10 } from './slide10';
import { thankYouPage } from './thank-you';


export const generateReportPPTX = async (data?: any) => {
    const pptxgen = (await import('pptxgenjs')).default;
    const pptx = new pptxgen();
    const candidateName = data?.candidateName;

    pptx.author = 'Access Excellentiam';
    pptx.company = 'Access Excellentiam';
    pptx.title = '360-Degree Feedback Report';
    pptx.subject = '360-Degree Feedback Report';
    // Define A4 Portrait layout (8.27 x 11.69 inches)
    pptx.defineLayout({ name: 'A4_PORTRAIT', width: 8.27, height: 11.69, });
    pptx.layout = 'A4_PORTRAIT';

    coverPage(pptx, data);
    slide1(pptx, {
        candidateName,
        data
    });

    slide2(pptx, {
        candidateName,
        data,
    });

    slide3(pptx, {
        candidateName,
        data
    });

    slide4(pptx, {
        candidateName,
        data,
    });

    slide5(pptx, {
        candidateName,
        data
    });
    slide6(pptx, {
        candidateName,
        data
    });

    slide7(pptx, {
        candidateName: candidateName,
        data
    });

    slide8(pptx, {
        candidateName,
        data
    });
    // slide9(pptx, {
    //     candidateName: candidateName
    // });
    slide10(pptx, {
        candidateName,
        data,
    });
    thankYouPage(pptx, {
        candidateName: candidateName
    });

    const fileName = `360_Feedback_Report_${candidateName.replace(/\s+/g, '_')}_${new Date().getTime()}.pptx`;

    // @ts-ignore
    pptx.writeFile(fileName);
    return fileName;
};
